<span class="cv-btn-label version-label" *ngIf="appVersion !== null">
        {{appVersion.environment}} | {{appVersion.tag}}
    <i class="versioning fas fa-info-circle" *ngIf="showSubmodules" (click)="onOpeningVersions($event)">
            <div class="tooltip" *ngIf="showVersioning">
                <div class="tooltip-inner" style="max-width: 100%;">
                    <div class="version-list">
                        <div class="system header">
                            <label class="name">System</label>
                            <label class="version" (click)="openSystemInfo($event)">Version <i
                                    class="fas fa-external-link-alt"></i></label>
                        </div>
                        <div class="system" *ngFor="let module of modules">
                            <label class="name">{{module.name}}</label>
                            <label class="version">{{module.version}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </i>
    </span>